module.exports = __webpack_public_path__ + "static/media/booking-no-input.884d4c4e.svg";